import { useContext } from 'react'
import { RouteContext } from './contexts'

export function Outlet() {
  const { outlet } = useContext(RouteContext)
  return outlet || null
}
